import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { Close } from '@sumup-oss/icons';
import { useTranslations } from 'next-intl';
import { Button } from '@ordering/components/ui/Button';
import { ResponsiveModalClose } from '@ordering/components/ui/responsive-modal';
import { sanitizeHtml } from '@ordering/utils/sanitizeHtml';
import { Body, Header } from '@ordering/components/ui/Typography';
import { ProductMedia } from '@ordering/components/shared/ProductMedia/ProductMedia';
import { cn } from '@ordering/utils/styling';
const getScrollParent = (element: HTMLElement | null) => {
  let parent = element?.parentElement ?? null;
  while (parent) {
    if (/(auto|scroll)/.test(getComputedStyle(parent).overflowY)) return parent;
    parent = parent.parentElement;
  }
  return null;
};
interface DrawerImageCoverProps {
  title?: string;
  description?: string;
  imageUrl?: string;
  videoUrl?: string;
  media?: React.ReactNode;
  imageAlt: string;
  children: React.ReactNode;
  onClose?: () => void;
}
export const DrawerImageCover = t0 => {
  const $ = _c(30);
  const {
    title,
    description,
    imageUrl,
    videoUrl,
    media,
    imageAlt,
    children,
    onClose
  } = t0;
  const t = useTranslations();
  const hasMedia = Boolean(media || imageUrl || videoUrl);
  const mediaAspect = videoUrl ? "aspect-[16/9]" : "aspect-[4/3]";
  const hiddenRatio = videoUrl ? 0 : 0.1875;
  let t1;
  if ($[0] !== hiddenRatio) {
    t1 = leadIn => {
      const scroller = getScrollParent(leadIn);
      if (!leadIn?.offsetHeight || !scroller) {
        return;
      }
      scroller.scrollTop = scroller.clientWidth * hiddenRatio;
    };
    $[0] = hiddenRatio;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openAtPeek = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("add_product_page.header.back_button.text");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Close />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClose || $[6] !== t2) {
    t4 = <ResponsiveModalClose asChild={true}><Button size="icon" variant="outline" className="absolute top-4 right-4 w-[32px] h-[32px] z-10" aria-label={t2} onClick={onClose}>{t3}</Button></ResponsiveModalClose>;
    $[5] = onClose;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const closeButton = t4;
  let t5;
  if ($[8] !== closeButton || $[9] !== hasMedia || $[10] !== imageAlt || $[11] !== imageUrl || $[12] !== media || $[13] !== mediaAspect || $[14] !== openAtPeek || $[15] !== videoUrl) {
    t5 = hasMedia && <><div className={cn("fixed top-0 left-0 right-0 z-20 xs:relative xs:w-full", mediaAspect)}>{closeButton}{media || <ProductMedia imageUrl={imageUrl} videoUrl={videoUrl} alt={imageAlt} />}</div><div ref={openAtPeek} aria-hidden={true} className={cn(mediaAspect, "xs:hidden")} /></>;
    $[8] = closeButton;
    $[9] = hasMedia;
    $[10] = imageAlt;
    $[11] = imageUrl;
    $[12] = media;
    $[13] = mediaAspect;
    $[14] = openAtPeek;
    $[15] = videoUrl;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = hasMedia ? "-mt-[28px]" : "mt-[10px]";
  let t7;
  if ($[17] !== t6) {
    t7 = cn("relative z-30 bg-background rounded-t-xl xs:z-auto xs:mt-0 xs:rounded-none", t6);
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = !hasMedia && closeButton;
  let t9;
  if ($[19] !== description || $[20] !== title) {
    t9 = title && <div className="px-8 p-4 pt-6 border-b border-border"><Header variant="s" weight="bold" className="pr-5">{title}</Header>{description && <Body variant="m" weight="regular" className="mt-2 text-subtle-text break-words"><span dangerouslySetInnerHTML={{
          __html: sanitizeHtml(description)
        }} /></Body>}</div>;
    $[19] = description;
    $[20] = title;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== children || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <div className={t7}>{t8}{t9}{children}</div>;
    $[22] = children;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[27] = t10;
    $[28] = t5;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};